import { Box, Image, Text, useTheme } from '@chakra-ui/react';
import React from 'react'
import badge13 from '../../innerAsstes/badgets/Recurso 13home badge.png';
import badge14 from '../../innerAsstes/badgets/Recurso 14home badge.png';
import badge15 from '../../innerAsstes/badgets/Recurso 15home badge.png';
import badge16 from '../../innerAsstes/badgets/Recurso 16home badge.png';
import badge20 from '../../innerAsstes/badgets/Recurso 20campus 1.11.png';
import badge21 from '../../innerAsstes/badgets/Recurso 21campus 1.11.png';
import badge22 from '../../innerAsstes/badgets/Recurso 22campus 1.11.png';
import badge23 from '../../innerAsstes/badgets/Recurso 23campus 1.11.png';
import { useAppContext } from '../../App';

export default function HomeBadges() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  
  const DoubleImgBadge = ({imgLeft, imgRight, customStyles = {}}) => {
    const style2 = styles2(theme, customStyles, isMobile);
    return (
      <Box style={style2.badgeContainer}>
        <Image style={style2.imgLeft} src={imgLeft} alt="Badge" />
        <Image style={style2.imgRight} src={imgRight} alt="Badge" />
      </Box>
    );
  }
  const textFontSize = {md: '2rem', sm:'1rem' }
  return (
    <div style={style.container}>
      <div style={style.badgesContainer}>
        <DoubleImgBadge imgLeft={badge14} imgRight={badge23} customStyles={style.doubleImgStyles1}/>
        <DoubleImgBadge imgLeft={badge15} imgRight={badge22} customStyles={style.doubleImgStyles2}/>
        <DoubleImgBadge imgLeft={badge13} imgRight={badge21} customStyles={style.doubleImgStyles3}/>
        <DoubleImgBadge imgLeft={badge16} imgRight={badge20} customStyles={style.doubleImgStyles3}/>
      </div>
      <div style={style.countersContainer} className='sansation-bold'>
        <div style={style.counter}>
          <div>
            <Text fontSize={textFontSize} style={style.number}>182</Text>
          </div>
          <Text fontSize={textFontSize} style={style.label}>CURSOS</Text>
        </div>
        <div style={style.counter}>
          <div>
            <Text fontSize={textFontSize}  style={style.number}>22659</Text>
          </div>
          <Text fontSize={textFontSize} style={style.label}>ESTUDIANTES</Text>
        </div>
        <div style={style.counter}>
          <div>
            <Text fontSize={textFontSize} style={style.number}>18358</Text>
          </div>
          <Text fontSize={textFontSize} style={style.label}>EGRESADOS</Text>
        </div>
      </div>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    marginLeft: '4vw',
    marginRight: '4vw',
  },
  badgesContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    borderTop: '1px white dashed',
    marginTop: 20,
    backgroundColor: theme.background.primary,
  },
  doubleImgStyles1: {
    container: {},
    imgRight:{
      width: isMobile? '60%' : 'auto',
    }
  },
  doubleImgStyles2: {
    container: {},
    imgRight:{
      width: isMobile? '60%' : 'auto',
    }
  },
  doubleImgStyles3: {
    container: {},
    imgRight:{
      width: isMobile? '60%' : 'auto',
    }
  },
  countersContainer: {
    display: 'flex',
    flexDirection: isMobile? 'column' : 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '2rem',
    paddingBottom: '2rem',
  },
  counter:{
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row', // Cambia aquí
    justifyContent: 'center', // Centrado en ambos casos
    alignItems: 'center',     // Centrado en ambos casos
    marginTop: isMobile ? '0.5rem' : 0,
    width: isMobile ? '100%' : '80%', // Mejor ancho en móvil
  },
  number:{
    padding: '0.5rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    minWidth: isMobile? '30vw' : 0,
    width: isMobile ? '100%' : 'auto', // Centrado en móvil
    color: theme.color.text.primary,
    background: theme.background.tertiary,
    textShadow: "5px 8px 3px rgba(0, 0, 0, 0.5)",
    textAlign: 'center', // Centra el texto

  },
  label: {
    padding: '0.5rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    color: theme.color.text.primary,
  }
});

const styles2 = (theme, customStyles, isMobile) => ({
  badgeContainer: {
    display: 'flex',
    flexDirection: isMobile? 'column' : 'row',
    alignItems: 'center',
    ...customStyles.container
  },
  imgLeft: {...customStyles.imgLeft},
  imgRight: {...customStyles.imgRight}
});
